export const getTinyMCEKey = () => {
  const keys = [
    process.env.REACT_APP_TINYMCE_KEY,
    process.env.REACT_APP_TINYMCE_KEY1,
    process.env.REACT_APP_TINYMCE_KEY2,
    process.env.REACT_APP_TINYMCE_KEY3,
  ];
  const randomIndex = Math.floor(Math.random() * keys.length);
  const selectedKey = keys[randomIndex];
  console.log(`[TinyMCE] Using API key (ending in): ${selectedKey.slice(-6)}`);
  return selectedKey;
};
